import { LedByCommunityGPORelation } from '../types'
import { LedByCommunityGroup } from './types'

export const formatTableData = (
  data: LedByCommunityGPORelation[],
  communityGPOId?: string
): LedByCommunityGroup[] =>
  data
    ? data.map((relation) => ({
        key:
          relation.gpo.uuid +
          relation.relations.reduce(
            (acc, item) => `${acc}${item.health_system.uuid}`,
            ''
          ),
        remaining: relation.gpo.remaining_to_be_distributed,
        gpo_allocation: relation.gpo.gpo_retain,
        canEditGPORetain: communityGPOId === relation.gpo.uuid,
        rows: relation.relations.map((row) => ({
          uuid: row.record.uuid,
          hs: row.health_system.name,
          co_retain: row.record.community_split,
          hs_split: row.record.hs_split
        }))
      }))
    : []

export const getRowClassName = (
  row: LedByCommunityGroup,
  canEditRow: boolean
) => {
  const isNotFulfilled =
    !row.gpo_allocation || !!row.rows.find((i) => !i.co_retain || !i.hs_split)
  return isNotFulfilled && canEditRow ? 'warning-highlight' : ''
}
